import axiosInstance from '../plugin/axios';

interface FetchSubContractParams {
  startDate: string;
  endDate: string;
  offset?: number;
  limit?: number;
  sortBy?: string;
  order?: 'asc' | 'desc';
}

interface SubContractResponse {
  subcontractId: number;
  target: string;
  state: string;
  createdAt: string;
}

interface SubContractRegistrationDto {
  target: string;
  content: string;
}

interface SubContractUpdateDto {
  target: string;
  content: string;
}

interface ServerResponse {
  statusCode: number;
  message: string;
}

interface SubContractDetailResponseData {
  subcontractId: number;
  vehicle: string;
  phone: string;
  target: string;
  content: string;
  state: string;
}

export const fetchSubContractList = async (
  params: FetchSubContractParams,
): Promise<SubContractResponse[]> => {
  try {
    const {
      startDate,
      endDate,
      offset = 0,
      limit = 1000,
      sortBy = 'target',
      order = 'desc',
    } = params;

    const response = await axiosInstance.get<SubContractResponse[]>(
      '/api/subcontract/driver',
      {
        params: {
          startDate,
          endDate,
          offset,
          limit,
          sortBy,
          order,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error('일감 내역 데이터를 불러오는 데 실패했습니다.', error);
    throw new Error('일감 내역 데이터를 불러오는 데 실패했습니다.');
  }
};

export const subContractRegistration = async (
  subContractData: SubContractRegistrationDto,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.post<ServerResponse>(
      '/api/subcontract/driver/registration',
      subContractData,
    );

    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchSubContractDetail = async (
  subcontractId: number,
): Promise<SubContractDetailResponseData> => {
  try {
    const response = await axiosInstance.get<SubContractDetailResponseData>(
      `/api/subcontract/driver/registration/${subcontractId}`,
    );

    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchSubContractUpdate = async (
  subcontractId: number,
  data: SubContractUpdateDto,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.put<ServerResponse>(
      `/api/subcontract/driver/registration/${subcontractId}`,
      data,
    );

    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchSubContractStateSetting = async (
  subcontractId: number,
  state: string,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.put<ServerResponse>(
      `/api/subcontract/driver/registration/state/${subcontractId}`,
      null, // PUT 요청이기 때문에 body는 null로 설정
      {
        params: { state }, // state를 query parameter로 보냅니다
      },
    );

    return response.data;
  } catch (error) {
    throw new Error();
  }
};

// company
export const fetchCompanySubContractList = async (
  params: FetchSubContractParams,
): Promise<SubContractResponse[]> => {
  try {
    const {
      startDate,
      endDate,
      offset = 0,
      limit = 1000,
      sortBy = 'target',
      order = 'desc',
    } = params;

    const response = await axiosInstance.get<SubContractResponse[]>(
      '/api/subcontract/company',
      {
        params: {
          startDate,
          endDate,
          offset,
          limit,
          sortBy,
          order,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error('일감 내역 데이터를 불러오는 데 실패했습니다.', error);
    throw new Error('일감 내역 데이터를 불러오는 데 실패했습니다.');
  }
};

export const fetchCompanySubContractDetail = async (
  subcontractId: number,
): Promise<SubContractDetailResponseData> => {
  try {
    const response = await axiosInstance.get<SubContractDetailResponseData>(
      `/api/subcontract/company/registration/${subcontractId}`,
    );

    return response.data;
  } catch (error) {
    console.error('일감 상세 내역 데이터를 불러오는 데 실패했습니다.', error);
    throw new Error();
  }
};
